
import React from 'react';
import DeviceHealthDashboard from '@/components/GasDeviceHealthDashboard';
import CompactLayout from '@/components/layout/CompactLayout';
import { Toaster } from '@/components/ui/toaster';

const GasDeviceHealth = () => {
  return (
    <CompactLayout>
      <div className="h-[calc(100vh-4rem)] overflow-hidden">
        <DeviceHealthDashboard />
      </div>
      <Toaster />
    </CompactLayout>
  );
};

export default GasDeviceHealth;
